import * as http from '@angular/common/http'
import * as ngCore from '@angular/core'
import type * as ents from '@attain-apps/entities'
import * as rxjs from 'rxjs'

import * as admin from '../admin'

/** Uploads, downloads, and deletes knowledge-base attribute documents. */
@ngCore.Injectable({ providedIn: 'root' })
export class Api {
  private readonly _http = ngCore.inject(http.HttpClient)

  /** Uploads a document to an existing knowledge-base data source. */
  public upload(
    input: ents.core.agent.KnowledgeBase.Management.UploadInput,
    file: File,
  ): rxjs.Observable<void> {
    return admin.agentKnowledgeBases.gql.mutations.createUploadRequest
      .execute(input)
      .pipe(
        rxjs.switchMap(request => {
          const formData = new FormData()
          for (const [key, value] of Object.entries(request.fields ?? {})) {
            formData.append(key, value)
          }
          // NOTE: this must appear last (at least for mocking, potentially also for S3)
          formData.append('file', file)

          return this._http
            .post(request.url, formData, { responseType: 'text' })
            .pipe(rxjs.map(() => undefined))
        }),
      )
  }

  /** Returns a temporary download URL for a document. */
  public createDownloadUrl(
    input: ents.core.agent.KnowledgeBase.Management.FileTarget,
  ): rxjs.Observable<string> {
    return admin.agentKnowledgeBases.gql.queries.createDownloadUrl.execute({
      input,
    })
  }

  /** Deletes a knowledge-base document. */
  public deleteFile(
    input: ents.core.agent.KnowledgeBase.Management.FileTarget,
  ): rxjs.Observable<boolean> {
    return admin.agentKnowledgeBases.gql.mutations.deleteFile.execute({
      input,
    })
  }
}
